// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import * as types from './actionTypes';

export function requestBasket(CartID, isChooseDeliv) {
  return {
    type: types.BASKET_REQUEST,
    CartID,
    isChooseDeliv,
  };
}

export function basketRequestSuccess(data) {
  return {
    type: types.BASKET_REQUEST_SUCCESS,
    basket: data,
  };
}

export function removeItem(deleteItem, token, customerId) {
  return {
    type: types.BASKET_REMOVE_ITEM,
    deleteItem,
    token,
    customerId,
  };
}


// SEARCH

export function requestBasketSearch(EAN) {
  return {
    type: types.BASKET_SEARCH_REQUEST,
    EAN,
  };
}

export function basketSearchRequestSuccess(data) {
  return {
    type: types.BASKET_SEARCH_REQUEST_SUCCESS,
    data
  };
}

export function basketSearchRequestFailed(data) {
  return {
    type: types.BASKET_SEARCH_REQUEST_FAILED,
    ...data
  };
}

export function cleanBasket(CartID) {
  return {
    type: types.CLEAN_BASKET,
    CartID,
  };
}

export function basketReset() {
  return {
    type: types.BASKET_RESET,
  };
}

// FIELDS

export function changeField(value, field) {
  return {
    type: types.BASKET_SEARCH_FIELD_CHANGE,
    value,
    field
  };
}

export function changeErrors(error, field) {
  return {
    type: types.BASKET_SEARCH_ERROR_CHANGE,
    field,
    error
  };
}

// TOTAL

export function setBasketTotal(total) {
  return {
    type: types.SET_BASKET_TOTAL,
    total,
  };
}

// LOADER

export function loadingStart() {
  return {
    type: types.LOADING_START,
    loading: true,
  };
}
export function loadingStop() {
  return {
    type: types.LOADING_STOP,
    loading: false,
  };
}

export function setVoucherCode(code) {
  return {
    type: types.SET_VOUCHER_CODE,
    code,
  };
}

export function setDeleteItem(item) {
  return {
    type: types.SET_DELETE_ID,
    item,
  };
}

export function getCartId() {
  return {
    type: types.GET_CART_ID,
  };
}

export function getIsEligibleForHomePickup(CartID, to) {
  return {
    type: types.GET_IS_ELIGIBLE_FOR_HOME_PICKUP,
    CartID,
    to,
  };
}

export function setIsEligibleForHomePickup(isEligibleForHomePickup) {
  return {
    type: types.SET_IS_ELIGIBLE_FOR_HOME_PICKUP,
    isEligibleForHomePickup,
  };
}

export function getBasketNotifyError(CartID) {
  return {
    type: types.GET_BASKET_NOTIFY_ERROR,
    CartID,
  };
}

export function setBasketNotifyError(error) {
  return {
    type: types.SET_BASKET_NOTIFY_ERROR,
    error,
  };
}

export function setDisableGetPriceButton(payload) {
  return {
    type: types.SET_DISABLE_GET_PRICE_BUTTON,
    payload,
  };
}

/** The grouped bookshop view of the basket, or null for ordinary customers. */
export const setBookshopBasket = bookshopBasket => ({
  type: types.SET_BOOKSHOP_BASKET,
  bookshopBasket,
});
